//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { ValueSetGroupModel } from './ValueSetGroupModel';
  
  export class CodeSystemVersionDashboardModel extends ModelBase {
      static readonly $typeName = 'CodeSystemVersionDashboardModel';
      public canAddValueSet: boolean;
      public canCreateDraft: boolean;
      public isDraft: boolean;
      public valueSetGroups: ValueSetGroupModel[];
      public vocabularyName: string;
      public vocabularyVersion: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/CodeSystemVersionDashboardModel.ts